// removed by extract-text-webpack-plugin
module.exports = {"field":"theme__field--2rog8","disabled":"theme__disabled--3HqAo","text":"theme__text--3b1B6","on":"theme__on--3ocqI","off":"theme__off--Ih3qa","thumb":"theme__thumb--3ryrT","ripple":"theme__ripple--1A_Pi","input":"theme__input--10E4S","switch-on":"theme__switch-on--2n4g1","switch-off":"theme__switch-off--105FO"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/switch/theme.scss
// module id = 332
// module chunks = 0